import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { connect } from "react-redux"
import { createStructuredSelector } from "reselect"
import CustomerProductEan from "components/customers/common/CustomerProductEan";
import Radio from '@material-ui/core/Radio';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemText from '@material-ui/core/ListItemText';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Grid from '@material-ui/core/Grid';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import {csrf, headers,money_format, date_format_without_time, date_format_without_time_and_zone} from "constants/csrf"
// Card
import Card from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardMedia from '@material-ui/core/CardMedia';
// Dialog
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Image from 'material-ui-image'
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import AddPhotoAlternateIcon from '@material-ui/icons/AddPhotoAlternate';
import DeleteIcon from '@material-ui/icons/Delete';
import GetAppIcon from '@material-ui/icons/GetApp';
import VisibilityIcon from '@material-ui/icons/Visibility';
import FileCopyIcon from '@material-ui/icons/FileCopy';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import { DropzoneArea } from 'material-ui-dropzone';
import {useTranslation} from "react-i18next"
import { flash_alert } from 'components/App';

import { SRLWrapper } from "simple-react-lightbox";


function VisitProducts(props){
    const { t } = useTranslation('translation', { keyPrefix: 'services.visits' });
    const [localCps, setLocalCps] = useState(props.visit.customer_products || []);
    const [localVcps, setLocalVcps] = useState(props.visit.visit_customer_products || []);
    const [isFetchingVisit, setIsFetchingVisit] = useState(true);

    const firstCp = localCps[0] || {};
    const firstVcp = localVcps.find(v => v.customer_product_id == firstCp.id) || localVcps[0] || {};

    const [checked, setChecked] = useState(firstCp.id || "");
    const [selectedCustomerProduct, setSelectedCustomerProduct] = useState(firstCp);
    const [selectedVisitCustomerProduct, setSelectedVisitCustomerProduct] = useState(firstVcp);
    const [images, setImages] = useState([]);
    const [uploadedFiles, setUploadedFiles] = useState([]);
    const [isUploading, setIsUploading] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showUploader, setShowUploader] = useState(false);
    const [descriptionErrors, setDescriptionErrors] = useState([]);
    const [deletingImageId, setDeletingImageId] = useState(null);
    const [isSaving, setIsSaving] = useState(false);
    const isServiceClosed = props.serviceStatusLabel === "Finalizado" || props.serviceStatusLabel === "Completado";
    const isVisitCompleted = props.visit.status === 'Visita completada';
    const isReadOnly = isServiceClosed || isVisitCompleted;

    // Editable fields state
    const [expertOpinion, setExpertOpinion] = useState("");
    const [activityPerformed, setActivityPerformed] = useState("");
    const [technicalDiagnosis, setTechnicalDiagnosis] = useState("");
    const [warranty, setWarranty] = useState("");
    const [installation, setInstallation] = useState(false);

    // Product identification fields (editable only if empty)
    const [productName, setProductName] = useState("");
    const [productTnr, setProductTnr] = useState("");
    const [productSerialId, setProductSerialId] = useState("");

    // Fetch fresh visit data on mount so we always have up-to-date VCP fields,
    // regardless of whether the parent re-renders after a save.
    useEffect(() => {
        fetch(`/api/v1/visits/${props.visit.id}`)
            .then(r => r.json())
            .then(json => {
                const freshVcps = json.data?.visit_customer_products || [];
                setLocalVcps(freshVcps);

                const cp0 = localCps[0] || {};
                const vcp0 = freshVcps.find(v => v.customer_product_id == cp0.id) || freshVcps[0] || {};
                // customer_product nested in VCP has fresh instalation_date
                const freshCpData = vcp0.customer_product || {};
                setSelectedVisitCustomerProduct(vcp0);
                setChecked(cp0.id || "");
                // Merge fresh instalation_date into the cp that has product/serial data
                setSelectedCustomerProduct({ ...cp0, instalation_date: freshCpData.instalation_date ?? cp0.instalation_date });

                // Update localCps with fresh instalation_date from each VCP's nested customer_product
                setLocalCps(prev => prev.map(cp => {
                    const vcp = freshVcps.find(v => v.customer_product_id == cp.id);
                    return vcp?.customer_product ? { ...cp, instalation_date: vcp.customer_product.instalation_date } : cp;
                }));

                setExpertOpinion(vcp0?.expert_opinion || cp0?.expert_opinion || "");
                setActivityPerformed(vcp0?.activity_performed || cp0?.activity_performed || "");
                setTechnicalDiagnosis(vcp0?.technical_diagnosis || cp0?.technical_diagnosis || "");
                setWarranty(vcp0?.warranty || cp0?.warranty || "");
                const freshInstalDate = freshCpData.instalation_date ?? null;
                setInstallation(freshInstalDate != null && freshInstalDate !== "");
                setProductName(cp0?.product?.name || "");
                setProductTnr(cp0?.product?.tnr || "");
                setProductSerialId(cp0?.serial_id || "");

                if (vcp0?.id) getProductImages(vcp0);
            })
            .catch(() => {
                // fallback: use props as-is
                const vcp0 = firstVcp;
                const cp0 = firstCp;
                setExpertOpinion(vcp0?.expert_opinion || cp0?.expert_opinion || "");
                setActivityPerformed(vcp0?.activity_performed || cp0?.activity_performed || "");
                setTechnicalDiagnosis(vcp0?.technical_diagnosis || cp0?.technical_diagnosis || "");
                setWarranty(vcp0?.warranty || cp0?.warranty || "");
                setInstallation(cp0?.instalation_date != null && cp0?.instalation_date !== "");
                setProductName(cp0?.product?.name || "");
                setProductTnr(cp0?.product?.tnr || "");
                setProductSerialId(cp0?.serial_id || "");
                if (vcp0?.id) getProductImages(vcp0);
            })
            .finally(() => setIsFetchingVisit(false));
    }, []);

     // Delete image dialog
     const [openDeleteImageDialog, setOpenDeleteImageDialog] = React.useState(false);
     const [currentDeleteImage, setCurrentDeleteImage] = React.useState("");

     // View image modal
     const [openViewImageModal, setOpenViewImageModal] = React.useState(false);
     const [viewImageData, setViewImageData] = React.useState(null);
     const [copySuccess, setCopySuccess] = React.useState(false);

     const handleOpenViewImage = (image, descriptionText) => {
        setViewImageData({ ...image, displayDescription: descriptionText });
        setOpenViewImageModal(true);
        setCopySuccess(false);
     };

     const handleCloseViewImage = () => {
        setOpenViewImageModal(false);
        setViewImageData(null);
        setCopySuccess(false);
     };

     const handleCopyDescription = async () => {
        if (viewImageData?.displayDescription) {
            try {
                await navigator.clipboard.writeText(viewImageData.displayDescription);
                setCopySuccess(true);
                setTimeout(() => setCopySuccess(false), 2000);
            } catch (err) {
                console.error('Failed to copy:', err);
            }
        }
     };

     const handleClickOpenImageDialog = (image_id) => {
        setCurrentDeleteImage(image_id)
        setOpenDeleteImageDialog(true);
     };

     const handleCloseImageDialog = () => {
         setOpenDeleteImageDialog(false);
     };

    async function handleDeleteImage(image) {
        setDeletingImageId(image.id);
        setOpenDeleteImageDialog(false);

        try {
            const response = await fetch(`/api/v1/file_resources/${image.id}`, {
                method: 'DELETE',
                headers: {
                    'X-CSRF-Token': csrf,
                    'Content-Type': 'application/json'
                }
            });

            if (response.ok) {
                flash_alert("", "Imagen eliminada correctamente", "success");
                // Refresh images
                if (selectedVisitCustomerProduct && selectedVisitCustomerProduct.id) {
                    getProductImages(selectedVisitCustomerProduct);
                }
            } else {
                const errorData = await response.json().catch(() => ({}));
                console.error('Delete failed:', response.status, errorData);
                flash_alert("", "Error al eliminar imagen", "error");
            }
        } catch (error) {
            console.error('Delete error:', error);
            flash_alert("", "Error al eliminar imagen", "error");
        } finally {
            setDeletingImageId(null);
            setCurrentDeleteImage(null);
        }
    }

    async function handleDownloadImage(image, event) {
        if (event) {
            event.stopPropagation();
            event.preventDefault();
        }

        try {
            // Get file extension from URL or default to jpg
            const urlParts = image.resource_url.split('.');
            const extension = urlParts.length > 1 ? urlParts[urlParts.length - 1].split('?')[0] : 'jpg';
            const filename = image.description ? `${image.description}.${extension}` : `product-image-${image.id}.${extension}`;

            // Fetch image through proxy to avoid CORS issues
            const response = await fetch(`/api/v1/file_resources/proxy_image?url=${encodeURIComponent(image.resource_url)}`);

            if (!response.ok) {
                throw new Error('Failed to fetch image');
            }

            const blob = await response.blob();
            const blobUrl = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = filename;
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();

            setTimeout(() => {
                document.body.removeChild(link);
                window.URL.revokeObjectURL(blobUrl);
            }, 100);

            // Old implementation (CORS issues with cross-origin images):
            // // Try direct download first (works if same origin or CORS enabled)
            // const link = document.createElement('a');
            // link.href = image.resource_url;
            // link.download = filename;
            // link.target = '_blank';
            // link.rel = 'noopener noreferrer';
            // link.style.display = 'none';
            // document.body.appendChild(link);
            // link.click();
            //
            // setTimeout(() => {
            //     document.body.removeChild(link);
            // }, 100);

        } catch (error) {
            console.error('Download error:', error);
            flash_alert("", "Error al descargar la imagen", "error");
        }
    }



    function handleToggle(customer_product, visit_customer_product){
        setChecked(customer_product.id)
        setSelectedCustomerProduct(customer_product)
        setSelectedVisitCustomerProduct(visit_customer_product)

        // Initialize editable fields with current values
        setExpertOpinion(visit_customer_product?.expert_opinion || customer_product?.expert_opinion || "")
        setActivityPerformed(visit_customer_product?.activity_performed || customer_product?.activity_performed || "")
        setTechnicalDiagnosis(visit_customer_product?.technical_diagnosis || customer_product?.technical_diagnosis || "")
        setWarranty(visit_customer_product?.warranty || customer_product?.warranty || "")
        setInstallation(customer_product?.instalation_date != null && customer_product?.instalation_date !== "")

        // Initialize product identification fields
        setProductName(customer_product?.product?.name || "")
        setProductTnr(customer_product?.product?.tnr || "")
        setProductSerialId(customer_product?.serial_id || "")

        visit_customer_product && getProductImages(visit_customer_product)
    }

    function getProductImages(visit_customer_product){
        var url = `/api/v1/file_resources/${visit_customer_product.id}/visit_customer_products`
        setIsLoading(true);
        fetch(url).then((response) => response.json())
        .then((json) => {
            if(json.data)
            {
                setImages(json.data)
            }
            setIsLoading(false)
        })
        .catch((error) => console.error(error) && setIsLoading(false));
      }

    function getBase64(file) {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => {
                const base64String = reader.result.split(',')[1];
                resolve({
                    uri_64: base64String,
                    name: file.name,
                    mime: file.type,
                });
            };
            reader.onerror = error => reject(error);
        });
    }

    async function onServiceChangeFiles(e) {
        if (e.length > 0) {
            const dT = [];
            e.forEach(async function(item) {
                await getBase64(item)
                    .then((encFile) => {
                        dT.push({
                            ...encFile,
                            description: '' // Initialize with empty description
                        })
                        setUploadedFiles(dT)
                    }).catch(error => console.log("error"));
            });
        } else {
            setUploadedFiles([]);
        }
    }

    function handleDescriptionChange(index, description) {
        const updatedFiles = [...uploadedFiles];
        updatedFiles[index].description = description;
        setUploadedFiles(updatedFiles);

        // Clear error for this field if user enters a description
        if (descriptionErrors.includes(index) && description.trim() !== '') {
            setDescriptionErrors(prev => prev.filter(i => i !== index));
        }
    }

    function validateDescriptions() {
        const errors = [];
        uploadedFiles.forEach((file, index) => {
            if (!file.description || file.description.trim() === '') {
                errors.push(index);
            }
        });
        setDescriptionErrors(errors);
        return errors.length === 0;
    }


    async function handleUploadImages() {
        if (!selectedVisitCustomerProduct || !selectedVisitCustomerProduct.id) {
            flash_alert("", "Por favor seleccione un producto primero", "error");
            return;
        }

        // Validate that all images have descriptions
        if (!validateDescriptions()) {
            flash_alert("", "Todas las imágenes deben tener una descripción", "error");
            return;
        }

        setIsUploading(true);

        try {
            const payload = {
                images: uploadedFiles.map(file => {
                    return {
                        uri_64: file.uri_64,
                        filename: file.name,
                        mime: file.mime,
                        description: file.description
                    };
                })
            };

            const response = await fetch(`/api/v1/file_resources/${selectedVisitCustomerProduct.id}/visit_customer_products`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': csrf
                },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                flash_alert("", "Imágenes subidas correctamente", "success");
                setTimeout(() => {
                    getProductImages(selectedVisitCustomerProduct);
                    if (props.onImagesUploaded) props.onImagesUploaded();
                }, 500);
                setUploadedFiles([]);
                setShowUploader(false);
            } else {
                const errorData = await response.json().catch(() => ({}));
                console.error('Upload failed:', response.status, errorData);
                flash_alert("", "Error al subir las imágenes", "error");
            }
        } catch (error) {
            console.error("Upload error:", error);
            flash_alert("", "Error al subir las imágenes", "error");
        } finally {
            setIsUploading(false);
        }
    }

    function handleMessage(message, type) {
        if (type == "error") {
            // Check if it's a file size error or file count error
            if (message && message.includes('File is too big')) {
                flash_alert("Error", "El archivo excede el tamaño máximo permitido de 10 MB. Por favor, seleccione una imagen más pequeña.", "error");
            } else if (message && message.includes('Maximum allowed number of files exceeded')) {
                flash_alert("Error", "Ha excedido el límite de 15 imágenes. Por favor, seleccione hasta 15 archivos como máximo.", "error");
            } else {
                flash_alert("Error", "Error al cargar el archivo. Verifique que el archivo sea válido y no exceda los límites permitidos.", "error");
            }
        }
    }

    async function handleUpdateProductFields() {
        if (!selectedCustomerProduct || !selectedCustomerProduct.id) {
            flash_alert("", "Por favor seleccione un producto primero", "error");
            return;
        }

        setIsSaving(true);

        try {
            const today = new Date().toISOString().split('T')[0];
            const payload = {
                customer_product_id: selectedCustomerProduct.id.toString(),
                visit_id: props.visit.id.toString(),
                expert_opinion: expertOpinion,
                activity_performed: activityPerformed,
                technical_diagnosis: technicalDiagnosis,
                warranty: warranty,
                instalation_date: installation ? (selectedCustomerProduct.instalation_date || today) : "",
            };

            // Always include product identification fields with current values
            // This prevents miele-core from nulling out fields not in the payload
            if (productName) {
                payload.product_name = productName;
            }
            if (productTnr) {
                payload.tnr = productTnr;
            }
            if (productSerialId) {
                payload.serial_id = productSerialId;
            }

            console.log('Update payload:', payload); // Debug log

            const response = await fetch(`/api/v1/customers/${props.visit.customer_id}/update_product`, {
                method: 'PATCH',
                headers: {
                    'Content-Type': 'application/json',
                    'X-CSRF-Token': csrf
                },
                body: JSON.stringify(payload)
            });

            if (response.ok) {
                flash_alert("", "Datos actualizados correctamente", "success");
                const updatedFields = {
                    expert_opinion: expertOpinion,
                    activity_performed: activityPerformed,
                    technical_diagnosis: technicalDiagnosis,
                    warranty: warranty,
                };
                const instalationDate = installation ? (selectedCustomerProduct.instalation_date || today) : null;
                setSelectedVisitCustomerProduct(prev => ({ ...prev, ...updatedFields }));
                setSelectedCustomerProduct(prev => ({ ...prev, instalation_date: instalationDate }));
                setLocalVcps(prev => prev.map(vcp =>
                    vcp.customer_product_id === selectedCustomerProduct.id
                        ? { ...vcp, ...updatedFields }
                        : vcp
                ));
                setLocalCps(prev => prev.map(cp =>
                    cp.id === selectedCustomerProduct.id
                        ? { ...cp, instalation_date: instalationDate }
                        : cp
                ));
            } else {
                const errorData = await response.json().catch(() => ({}));
                console.error('Update failed:', response.status, errorData);
                flash_alert("", "Error al actualizar los datos", "error");
            }
        } catch (error) {
            console.error("Update error:", error);
            flash_alert("", "Error al actualizar los datos", "error");
        } finally {
            setIsSaving(false);
        }
    }


	if (isFetchingVisit) {
        return <div style={{ display: 'flex', justifyContent: 'center', padding: '40px' }}><CircularProgress /></div>;
    }

	return (
		<React.Fragment>
            <List>
                {localCps && localCps.map((customer_product) => {
                    const listId = `list-visit-products-${props.visit.id}-${customer_product.id}`;
                    const labelId = `visit-products-${props.visit.id}-${customer_product.id}`;
                    const visit_customer_product = localVcps.find(visit_customer_product => visit_customer_product.customer_product_id ==  customer_product.id)
                    return (
                    <ListItem key={listId} role={undefined} dense button onClick={() => handleToggle(customer_product, visit_customer_product)}>
                        <ListItemIcon className="service-address-label">
                        <FormControlLabel value={customer_product.id} control={<Radio color="primary"/>} label="" checked={checked == customer_product.id}
                            tabIndex={-1}
                        />
                        </ListItemIcon>
                        <ListItemText
                            id={labelId}
                            secondaryTypographyProps={{ component: 'div' }}
                            secondary={
                                <Grid container spacing={1}>
                                    <Grid item xs={12} sm={4}>
                                        <span className="visit-summary-1">{t('productTableInfo.name')}</span><br/>
                                        <span className="visit-summary-2">{customer_product.product.name}</span>
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <span className="visit-summary-1">{t('productTableInfo.tnr')}</span><br/>
                                        <span className="visit-summary-2">{customer_product.product.tnr}</span>
                                    </Grid>
                                    <Grid item xs={12} sm={3}>
                                        <span className="visit-summary-1">{t('productTableInfo.id')}</span><br/>
                                        <CustomerProductEan key={customer_product.serial_id} serial_id={customer_product.serial_id} b2b_ean={customer_product.b2b_ean}/>
                                    </Grid>
                                    <Grid item xs={12} sm={2}>
                                        <span className="visit-summary-1">{t('productTableInfo.status')}</span><br/>
                                        <span className="visit-summary-2">{customer_product.status}</span>
                                    </Grid>
                                </Grid>
                            }
                        />


                        <ListItemSecondaryAction>

                        </ListItemSecondaryAction>
                    </ListItem>
                    );
                })}
                
                </List>

                {/* Product Identification Fields - Editable only if empty */}
                <Grid style={{marginTop: "15px", marginBottom: "15px", padding: "15px", backgroundColor: "#f5f5f5", borderRadius: "4px"}} container spacing={1}>
                    <Grid item xs={12}>
                        <p className="service-p" style={{margin: "0 0 10px 0", fontWeight: "500"}}>
                            {t('productTableInfo.productIdentification') || 'Identificación del Producto'}
                        </p>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            label={t('productTableInfo.name') || 'Nombre'}
                            value={productName}
                            onChange={(e) => setProductName(e.target.value)}
                            disabled={!!(selectedCustomerProduct?.product?.name) || isReadOnly}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            label={t('productTableInfo.tnr') || 'TNR'}
                            value={productTnr}
                            onChange={(e) => setProductTnr(e.target.value)}
                            disabled={!!(selectedCustomerProduct?.product?.tnr) || isReadOnly}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            label={t('productTableInfo.id') || 'ID / Serial'}
                            value={productSerialId}
                            onChange={(e) => setProductSerialId(e.target.value)}
                            disabled={!!(selectedCustomerProduct?.serial_id) || isReadOnly}
                        />
                    </Grid>
                </Grid>

                <Grid style={{marginTop: "15px"}} container spacing={1}>
                    <Grid item xs={12} sm={4}>
                        <FormControl variant="outlined" fullWidth size="small">
                            <InputLabel id="expert-opinion-label">{t('expertOpinion')}</InputLabel>
                            <Select
                                labelId="expert-opinion-label"
                                id="expert-opinion-select"
                                value={expertOpinion}
                                label={t('expertOpinion')}
                                onChange={(e) => setExpertOpinion(e.target.value)}
                                disabled={isReadOnly}
                            >
                                <MenuItem value="">
                                    <em>Seleccionar</em>
                                </MenuItem>
                                <MenuItem value="Fuga de Agua">Fuga de Agua</MenuItem>
                                <MenuItem value="Indicador de alarma/problema">Indicador de alarma/problema</MenuItem>
                                <MenuItem value="Problema de calibración">Problema de calibración</MenuItem>
                                <MenuItem value="Suciedad o material extraño">Suciedad o material extraño</MenuItem>
                                <MenuItem value="Ajuste de equipo requerido">Ajuste de equipo requerido</MenuItem>
                                <MenuItem value="Ruido excesivo">Ruido excesivo</MenuItem>
                                <MenuItem value="Vibración excesiva">Vibración excesiva</MenuItem>
                                <MenuItem value="Desalineamiento">Desalineamiento</MenuItem>
                                <MenuItem value="No enciende">No enciende</MenuItem>
                                <MenuItem value="Sobrecalentamiento">Sobrecalentamiento</MenuItem>
                                <MenuItem value="Partes/equipo fisicamente roto">Partes/equipo fisicamente roto</MenuItem>
                                <MenuItem value="Corto circuito">Corto circuito</MenuItem>
                                <MenuItem value="No arranca">No arranca</MenuItem>
                                <MenuItem value="Mantenimiento">Mantenimiento</MenuItem>
                                <MenuItem value="Otros">Otros</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <FormControl variant="outlined" fullWidth size="small">
                            <InputLabel id="activity-performed-label">{t('activityPerformed')}</InputLabel>
                            <Select
                                labelId="activity-performed-label"
                                id="activity-performed-select"
                                value={activityPerformed}
                                label={t('activityPerformed')}
                                onChange={(e) => setActivityPerformed(e.target.value)}
                                disabled={isReadOnly}
                            >
                                <MenuItem value="">
                                    <em>Seleccionar</em>
                                </MenuItem>
                                <MenuItem value="Ajuste mecánico">Ajuste mecánico</MenuItem>
                                <MenuItem value="Ajuste eléctrico/electrónico">Ajuste eléctrico/electrónico</MenuItem>
                                <MenuItem value="Reemplazo de partes">Reemplazo de partes</MenuItem>
                                <MenuItem value="Limpieza/mantenimiento">Limpieza/mantenimiento</MenuItem>
                                <MenuItem value="No presenta falla">No presenta falla</MenuItem>
                                <MenuItem value="Equipo irreparable">Equipo irreparable</MenuItem>
                                <MenuItem value="Otros">Otros</MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <TextField
                            fullWidth
                            variant="outlined"
                            size="small"
                            label={t('technicalDiagnosis')}
                            value={technicalDiagnosis}
                            onChange={(e) => setTechnicalDiagnosis(e.target.value)}
                            inputProps={{ maxLength: 3000 }}
                            multiline
                            minRows={6}
                            maxRows={20}
                            helperText={`${technicalDiagnosis.length}/3000`}
                            disabled={isReadOnly}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={warranty === "Si" || warranty === "Yes" || warranty === true}
                                    onChange={(e) => setWarranty(e.target.checked ? "Si" : "No")}
                                    color="primary"
                                    disabled={isReadOnly}
                                />
                            }
                            label={t('warranty')}
                        />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={installation}
                                    onChange={(e) => setInstallation(e.target.checked)}
                                    color="primary"
                                    disabled={isReadOnly}
                                />
                            }
                            label={t('instalationDate')}
                        />
                    </Grid>
                    <Grid item xs={12} style={{marginTop: "10px", textAlign: "right"}}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleUpdateProductFields}
                            disabled={isSaving || !selectedCustomerProduct.id || isReadOnly}
                        >
                            {isSaving ? <CircularProgress size={24} /> : 'Actualizar'}
                        </Button>
                    </Grid>
                </Grid>
                <SRLWrapper>
                <Grid container spacing={2}>
                    {images.length > 0 &&
                        <Grid item xs={12}>
                            <p className="service-p">Archivos cargados</p>
                        </Grid>
                    }
                    {images && images.map((image) => {
                        const labelId = `file-list-label-${image.id}`;

                        // Extract description from filename
                        let descriptionText = '';

                        // Try to get filename from description field first
                        let rawFilename = image.description;

                        // If description is null, extract filename from resource_url
                        if (!rawFilename && image.resource_url) {
                            const urlParts = image.resource_url.split('/');
                            rawFilename = decodeURIComponent(urlParts[urlParts.length - 1]);
                        }

                        // Remove file extension to get description
                        if (rawFilename) {
                            const parts = rawFilename.split('.');
                            descriptionText = parts.length > 1 ? parts.slice(0, -1).join('.') : rawFilename;
                        }

                        return (
                            <Grid key={labelId} item xs={6} sm={4} md={3}>
                                <Card>
                                    <CardActionArea>
                                            <a href={image.resource_url}>
                                                <Image
                                                    src={image.resource_url}
                                                    className="file-image"
                                                    srl_gallery_image="true"
                                                />
                                            </a>
                                    </CardActionArea>
                                    {
                                    <CardActions style={{ display: 'flex', justifyContent: 'space-between', padding: '8px', flexDirection: 'column', alignItems: 'stretch' }}>
                                        <div style={{ marginBottom: '8px', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }} title={descriptionText}>
                                            <a target="_blank" href={image.resource_url} className="mdl-navigation__link brand-link" style={{ fontSize: '12px' }}>
                                                {descriptionText || 'Sin descripción'}
                                            </a>
                                        </div>
                                        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                            <IconButton
                                                size="small"
                                                color="primary"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    e.preventDefault();
                                                    handleOpenViewImage(image, descriptionText);
                                                }}
                                                title="Ver imagen"
                                            >
                                                <VisibilityIcon fontSize="small" />
                                            </IconButton>
                                            <IconButton
                                                size="small"
                                                color="primary"
                                                onClick={(e) => handleDownloadImage(image, e)}
                                                title="Descargar"
                                                disabled={deletingImageId === image.id}
                                            >
                                                <GetAppIcon fontSize="small" />
                                            </IconButton>
                                            <IconButton
                                                size="small"
                                                color="secondary"
                                                onClick={(e) => {
                                                    e.stopPropagation();
                                                    e.preventDefault();
                                                    handleClickOpenImageDialog(image.id);
                                                    setCurrentDeleteImage(image);
                                                }}
                                                title="Eliminar"
                                                disabled={deletingImageId === image.id || isReadOnly}
                                            >
                                                {deletingImageId === image.id ? (
                                                    <CircularProgress size={20} color="secondary" />
                                                ) : (
                                                    <DeleteIcon fontSize="small" />
                                                )}
                                            </IconButton>
                                        </div>
                                    </CardActions>

                                    }
                                </Card>
                            </Grid>
                        );
                    })}

                    {/* Upload Card */}
                    <Grid item xs={6} sm={4} md={3}>
                        <Card
                            elevation={0}
                            style={{
                                height: '100%',
                                minHeight: '200px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                border: '2px dashed #2196f3',
                                backgroundColor: '#f8f9ff',
                                cursor: 'pointer',
                                boxShadow: 'none'
                            }}
                        >
                            <CardActionArea
                                onClick={() => !isReadOnly && setShowUploader(true)}
                                disabled={isReadOnly}
                                style={{
                                    height: '100%',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    flexDirection: 'column',
                                    padding: '20px',
                                    WebkitTapHighlightColor: 'transparent',
                                    opacity: isReadOnly ? 0.5 : 1
                                }}
                            >
                                <AddPhotoAlternateIcon style={{ fontSize: '48px', color: isReadOnly ? '#999' : '#2196f3', marginBottom: '10px' }} />
                                <p style={{ margin: 0, color: isReadOnly ? '#999' : '#2196f3', fontWeight: '500', fontSize: '14px', textAlign: 'center' }}>
                                    Subir imágenes
                                </p>
                            </CardActionArea>
                        </Card>
                    </Grid>

                {/* Delete Image Dialog */}
                <Dialog open={openDeleteImageDialog} onClose={handleCloseImageDialog} aria-labelledby="form-dialog-title">
                    <DialogTitle id="form-dialog-title">Eliminar foto</DialogTitle>
                    <DialogContent>
                        <DialogContentText>
                            ¿Está seguro que desea eliminar este archivo?
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseImageDialog} color="primary">
                            Cancelar
                        </Button>
                        <Button onClick={() => handleDeleteImage(currentDeleteImage)} color="secondary" variant="contained">
                            Eliminar
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* View Image Modal */}
                <Dialog
                    open={openViewImageModal}
                    onClose={handleCloseViewImage}
                    maxWidth="md"
                    fullWidth
                >
                    <DialogTitle style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                        Ver imagen
                    </DialogTitle>
                    <DialogContent>
                        {viewImageData && (
                            <>
                                <div style={{ textAlign: 'center', marginBottom: '16px' }}>
                                    <img
                                        src={viewImageData.resource_url}
                                        alt={viewImageData.displayDescription || 'Imagen'}
                                        style={{ maxWidth: '100%', maxHeight: '60vh', objectFit: 'contain' }}
                                    />
                                </div>
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'space-between',
                                    padding: '12px',
                                    backgroundColor: '#f5f5f5',
                                    borderRadius: '4px',
                                    marginTop: '8px'
                                }}>
                                    <div style={{ flex: 1, marginRight: '12px' }}>
                                        <strong>Descripción:</strong>
                                        <p style={{ margin: '4px 0 0 0', wordBreak: 'break-word' }}>
                                            {viewImageData.displayDescription || 'Sin descripción'}
                                        </p>
                                    </div>
                                    {viewImageData.displayDescription && (
                                        <Tooltip title={copySuccess ? "¡Copiado!" : "Copiar descripción"}>
                                            <IconButton
                                                onClick={handleCopyDescription}
                                                color={copySuccess ? "primary" : "default"}
                                                size="small"
                                            >
                                                <FileCopyIcon />
                                            </IconButton>
                                        </Tooltip>
                                    )}
                                </div>
                            </>
                        )}
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleCloseViewImage} color="primary" variant="contained">
                            Cerrar
                        </Button>
                    </DialogActions>
                </Dialog>

                {/* Upload Dialog */}
                <Dialog
                    open={showUploader}
                    onClose={() => setShowUploader(false)}
                    maxWidth="md"
                    fullWidth
                    fullScreen={window.innerWidth < 600}
                >
                    <DialogTitle>Subir imágenes del producto</DialogTitle>
                    <DialogContent style={{ paddingBottom: '20px' }}>
                        <DropzoneArea
                            name='product_images'
                            dropzoneText={t('fileUploadInstructions', { defaultValue: 'Arrastre su archivo aquí, o haga click para seleccionarlo' })}
                            onChange={onServiceChangeFiles}
                            showPreviews={true}
                            showPreviewsInDropzone={false}
                            useChipsForPreview
                            previewGridProps={{ container: { spacing: 1, direction: 'row' } }}
                            previewText={t('payments.selectedFiles')}
                            filesLimit={15}
                            showAlerts={false}
                            maxFileSize={10000000}
                            alertSnackbarProps={{ anchorOrigin: { vertical: 'top', horizontal: 'right' } }}
                            onAlert={handleMessage}
                        />
                        {uploadedFiles.length > 0 && (
                            <div style={{ marginTop: '20px' }}>
                                <p style={{ marginBottom: '10px', fontWeight: '500' }}>Descripciones (obligatorias):</p>
                                {uploadedFiles.map((file, index) => (
                                    <TextField
                                        key={index}
                                        fullWidth
                                        size="small"
                                        variant="outlined"
                                        label={`Descripción para ${file.name} *`}
                                        value={file.description || ''}
                                        onChange={(e) => handleDescriptionChange(index, e.target.value)}
                                        style={{ marginBottom: '10px' }}
                                        placeholder="Escriba una descripción para esta imagen"
                                        required
                                        inputProps={{ maxLength: 400 }}
                                        error={descriptionErrors.includes(index)}
                                        helperText={descriptionErrors.includes(index) ? "La descripción es obligatoria" : `${(file.description || '').length}/400`}
                                    />
                                ))}
                            </div>
                        )}
                    </DialogContent>
                    <DialogActions style={{ padding: '16px' }}>
                        <Button onClick={() => setShowUploader(false)} color="secondary">
                            Cancelar
                        </Button>
                        <Button
                            onClick={handleUploadImages}
                            color="primary"
                            disabled={isUploading || uploadedFiles.length === 0 || uploadedFiles.some(f => !f.description?.trim())}
                            variant="contained"
                        >
                            {isUploading ? <CircularProgress size={24} /> : 'Subir'}
                        </Button>
                    </DialogActions>
                </Dialog>
                </Grid>
                </SRLWrapper>
		</React.Fragment>
	);
  
}

const structuredSelector = createStructuredSelector({
});
const mapDispatchToProps = {};

export default connect(structuredSelector, mapDispatchToProps)(VisitProducts)

